module.exports = __webpack_public_path__ + "static/media/Menu-Boats.43b68c47.jpg";